import React from 'react';
import { DocumentalValidationErrorCode } from "./deprecated-documental-validation";
import { useTranslation } from 'react-i18next';
import { nsnewo } from "../../../i18n/namespaces";
export const DocumentalValidationError = props => {
  const {
    t
  } = useTranslation(nsnewo.common);
  switch (props.code) {
    case DocumentalValidationErrorCode.NO_OPTION_SELECTED:
      return /*#__PURE__*/React.createElement("small", {
        className: "text-red"
      }, t('newo.documentalValidationError.noOptionSelected'));
    case DocumentalValidationErrorCode.NO_ACCEPTED_FILE:
      return /*#__PURE__*/React.createElement("small", {
        className: "text-red"
      }, t('newo.documentalValidationError.noAcceptedFile'));
    case DocumentalValidationErrorCode.LOW_FILE_QUALITY:
      return /*#__PURE__*/React.createElement("small", {
        className: "text-red"
      }, t('newo.documentalValidationError.lowFileQuality'));
    case DocumentalValidationErrorCode.DOCUMENT_EDM_ERROR:
      return /*#__PURE__*/React.createElement("small", {
        className: "text-red"
      }, t('newo.documentalValidationError.error'));
    default:
      return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
};